export default __webpack_public_path__ + "static/media/grafema_gim-tonico_04.f0d42bef.jpg";